import { render, staticRenderFns } from "./SeguimientoTab.vue?vue&type=template&id=2a2e4fdc&scoped=true&lang=pug"
import script from "./SeguimientoTab.vue?vue&type=script&lang=js"
export * from "./SeguimientoTab.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoTab.vue?vue&type=style&index=0&id=2a2e4fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e4fdc",
  null
  
)

export default component.exports